import request from '@/utils/request'
import {guid} from "@/utils/ruoyi";


// 查询商品列表
export function listGoods(query) {
  return request({
    url: '/goods/goods/point/list',
    method: 'get',
    params: query
  })
}

// 查询商品分页
export function pageGoods(data) {
  data.date=guid()
  return request({
    url: '/goods/goods/point/page',
    method: 'post',
    data: data
  })
}
// 查询商品分页
export function activePage(data) {
  data.date=guid()
  return request({
    url: '/goods/goods/point/activePage',
    method: 'post',
    data: data
  })
}
// 查询商品详细
export function getGoods(data) {
  return request({
    url: '/goods/goods/point/detail',
    method: 'get',
    params: data
  })
}

// 新增商品
export function addGoods(data) {
  return request({
    url: '/goods/goods/point/add',
    method: 'post',
    data: data
  })
}

// 修改商品
export function updateGoods(data) {
  return request({
    url: '/goods/goods/point/edit',
    method: 'post',
    data: data
  })
}

// 删除商品
export function delGoods(data) {
  return request({
    url: '/goods/goods/point/delete',
    method: 'post',
    data: data
  })
}


export function batchOn(data) {
  return request({
    url: '/goods/goods/point/batchOn',
    method: 'post',
    data: data
  })
}


export function batchOff(data) {
  return request({
    url: '/goods/goods/point/batchOff',
    method: 'post',
    data: data
  })
}

export function batchCopy(data) {
  return request({
    url: '/goods/goods/point/copy',
    method: 'post',
    data: data
  })
}

// 从普通商品复制创建积分商品（新接口）
export function copyFromNormalGoods(data) {
  return request({
    url: '/goods/goods/point/copyFromNormal',
    method: 'post',
    data: data
  })
}

// 编辑积分商品的积分价格（新接口）
export function editPointPrice(data) {
  return request({
    url: '/goods/goods/point/editPointPrice',
    method: 'post',
    data: data
  })
}

// 根据积分商品ID查询SKU列表
export function getSkuListByPointGoodsId(pointGoodsId) {
  return request({
    url: '/goods/goods/point/skuList',
    method: 'get',
    params: { pointGoodsId }
  })
}

// 获取当前用户可创建积分商品的门店列表（平台所有门店/商家名下门店/门店自身）
export function getSelectableShops() {
  return request({
    url: '/goods/goods/point/selectableShops',
    method: 'get'
  })
}